import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepFeedback extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Feedback: Resource Representations</h1>
				<h2>Feedback</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> feedback_id </td>
							<td> Integer </td>
							<td> An identification of the feedback </td>
							<td> </td>
						</tr>
						<tr>
							<td> order_id </td>
							<td> Integer </td>
							<td> The ID of the order associated with the feedback </td>
							<td> </td>
						</tr>
						<tr>
							<td> from </td>
							<td> String </td>
							<td> The username of who posts this feedback </td>
							<td> </td>
						</tr>
						<tr>
							<td> to </td>
							<td> String </td>
							<td> The username of who receives this feedback  </td>
							<td> </td>
						</tr>
						<tr>
							<td> date_rated </td>
							<td> Timestamp </td>
							<td> The time the feedback was posted </td>
							<td> </td>
						</tr>
						<tr>
							<td> rating </td>
							<td> Integer </td>
							<td> The rating for a transaction (scale 0 to 2) </td>
							<td> 0: Praise, 1: Neutral, 2: Complaint </td>
						</tr>
						<tr>
							<td> rating_of_bs </td>
							<td> String </td>
							<td> Indicates whether the feedback is written for a seller or a buyer </td>
							<td> S: Seller, B: Buyer </td>
						</tr>
						<tr>
							<td> comment </td>
							<td> String </td>
							<td> A comment associated with the feedback </td>
							<td> </td>
						</tr>
						<tr>
							<td> reply </td>
							<td> String </td>
							<td> A reply for this feedback </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "feedback_id":6628516,
    "order_id":3986441,
    "from":"covariance1",
    "to":"sklee",
    "date_rated":"2013-12-17T07:25:00.000Z",
    "rating":0,
    "rating_of_bs":"S",
    "comment":"Excellent! Thank you!" 
}`}</Highlight>
			</section>
		);
	}
}